import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { EmojiIcon } from '../EmojiIcon';
import styles from './QuestionAnswerSlideV3.css';

const cx = classnames.bind(styles);
const DELAY = 600;

function QuestionAnswerSlideV3({ question, answers, submitAnswer, userResponse, description, submitTemporaryAnswer, id, delay, image, spriteVersion }) {
    const [isPending, setIsPending] = useState(false);

    useEffect(() => {
        if (id) {
            setIsPending(false);
        }
    }, [id]);

    useEffect(() => {
        if (userResponse.id && userResponse.isPending) {
            setIsPending(true);

            const { isPending: isTemporaryPending, ...answerData } = userResponse; /* eslint-disable-line */

            const timeoutId = setTimeout(() => {
                submitAnswer(answerData)();
            }, delay);

            return () => clearTimeout(timeoutId);
        }
    }, [userResponse.id, userResponse.isPending]);

    const handleChange = answer => () => {
        if (isPending) return;

        submitTemporaryAnswer({ ...answer, questionId: id, question, isPending: true });
    };

    return (
        <div className={styles.form} key={id}>
            <p className={cx('question', { withDescription: Boolean(description) })}>{question}</p>
            {Boolean(description) && <p className={styles.description}>{description}</p>}
            {Boolean(image) && (
                <div className={styles.imageCard}>
                    <img src={image} alt='' className={styles.image} />
                </div>
            )}
            <ul className={styles.answers}>
                {answers.map(answer => {
                    const isChecked = userResponse?.id === answer.id;
                    const classes = cx({
                        answer: true,
                        checked: isChecked
                    });

                    return (
                        <li key={answer.id} className={classes}>
                            <button
                                type='button'
                                onClick={handleChange(answer)}
                                className={styles.answerButton}
                                aria-pressed={isChecked}
                            >
                                {answer.icon && spriteVersion && (
                                    <EmojiIcon name={answer.icon} version={spriteVersion} />
                                )}
                                <span className={styles.answerText}>{answer.text}</span>
                                <span className={styles.answerIcon}>
                                    <Icon name='chevronRight' />
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

QuestionAnswerSlideV3.propTypes = {
    question: PropTypes.string.isRequired,
    answers: PropTypes.array.isRequired,
    submitAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object,
    description: PropTypes.string,
    image: PropTypes.string,
    delay: PropTypes.number,
    spriteVersion: PropTypes.string
};

QuestionAnswerSlideV3.defaultProps = {
    userResponse: {},
    description: '',
    image: '',
    delay: DELAY
};

export {
    QuestionAnswerSlideV3
};
